// Dependencies
import React, { useEffect, useState, useMemo } from "react";

// Modules
import { useSelector } from "react-redux";

// App
    // eslint-disable-next-line react-hooks/exhaustive-deps
import { apiEndpoints } from "../../config";
import MediaLibrary from "../../partials/mediaLibrary";
import { get_csrf_token } from "../../core/auth";

import { Button, TextField } from "@mui/material";

import PostEdit from "../../partials/posts/postEdit";

export default function PodcastEdit() {
  const [post, setPost] = useState(null);
  const [showMediaLibrary, setShowMediaLibrary] = useState(false);
  const [csrf_token, setCsrfToken] = useState(null);
  const [audioArtist, setAudioArtist] = useState("");
  const [audioMid, setAudioMid] = useState(null);
  const [audioSrc, setAudioSrc] = useState(null);
  const user = useSelector((state) => state.authReducer.user);

  useEffect(() => {
    get_csrf_token().then((response) => setCsrfToken(response.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!post) return;
    if (post.field_audio && !audioMid) {
      setAudioSrc(post.field_audio);
    }
    if (post.field_artist) {
      setAudioArtist(post.field_artist);
    }
    // eslint-disable-next-line
  }, [post]);

  const extraFields = useMemo(() => {
    const audioData = audioMid ? { field_audio: audioMid } : {};
    const artistData = audioArtist ? { field_artist: audioArtist } : {};
    return { ...audioData, ...artistData };
  }, [audioMid, audioArtist]);

  return (
    <PostEdit
      entityType={"podcast"}
      apiEndpoint={apiEndpoints.podcasts}
      screenClassName={"podcasts"}
      categoryTitle={"Podcast category"}
      categoryName={"field_podcast_category"}
      targetVid={"podcast_categories"}
      returnRoute={"/podcasts-creator"}
      backBtnText={"Podcast Library"}
      previewRoute={"/podcasts/preview"}
      logCustomEventType={"Podcast"}
      extraFields={extraFields}
      featuredImageEnabled={true}
      editorProps={{ 
        title: true,
        summary: true,
        body: true,
        list: true,
      }}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
      <Button
        variant="outlined"
        component="label"
        size="small"
        onClick={() => {
          setShowMediaLibrary(true);
        }}
      >
        Select Audio
      </Button>
      {audioSrc && (
        <audio
          key={`player-${audioSrc}`}
          controls
          className="post-podcast w-100 mt-4 mb-3"
        >
          <source src={audioSrc} alt={`Audio for ${post.title}`} />
        </audio>
      )}
      <TextField
        label="Artist"
        variant="outlined"
        value={audioArtist}
        onChange={(e) => setAudioArtist(e.target.value)}
        size="small"
      />
      {showMediaLibrary && (
        <MediaLibrary
          user={user}
          csrf_token={csrf_token}
          mediaType={"audio"}
          showMediaLibrary={showMediaLibrary}
          setShowMediaLibrary={setShowMediaLibrary}
          onMediaInsert={(media) => {
            setAudioSrc(media.src);
            setAudioMid(parseInt(media.mid));
            setShowMediaLibrary(false);
          }}
        />
      )}
    </PostEdit>
  );
}
